module.exports = __webpack_public_path__ + "img/battery-consumption.92b9eb72.svg";